import styled from "styled-components";

import { styles } from "../Input/styles";

interface IProps {
  disabled?: boolean;
}

export const Container = styled.div``;

export const Input = styled.div<IProps>`
  ${styles}

  display: flex;
  align-items: center;

  &:focus-within {
    box-shadow: var(--input-focus-shadow);
  }

  &.disabled {
    background-color: var(--input-disabled-background);
    border-color: var(--input-disabled-border);

    &&:hover {
      border-color: var(--input-disabled-border);
    }
  }

  input {
    width: 100%;

    border: 0;
    background: transparent;

    font-size: 1rem;
  }
`;

export const EyeContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: 0.5rem;

  border: 0;
  background: transparent;
`;
